var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { Column, CreateDateColumn, Entity, Index, PrimaryColumn, UpdateDateColumn } from 'typeorm';
let Job = class Job {
    id;
    createdDate;
    updatedDate;
    startDate;
    status;
    retryCount;
    duration;
    type;
    data;
    result;
    error;
};
__decorate([
    PrimaryColumn('uuid', { default: () => 'uuidv7()' }),
    __metadata("design:type", String)
], Job.prototype, "id", void 0);
__decorate([
    Index(),
    CreateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], Job.prototype, "createdDate", void 0);
__decorate([
    Index(),
    UpdateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], Job.prototype, "updatedDate", void 0);
__decorate([
    Column({ type: 'timestamp', nullable: true }),
    __metadata("design:type", Date)
], Job.prototype, "startDate", void 0);
__decorate([
    Index(),
    Column({ type: 'enum', enum: ['pending', 'processing', 'completed', 'failed'], default: 'pending' }),
    __metadata("design:type", String)
], Job.prototype, "status", void 0);
__decorate([
    Column({ default: 0 }),
    __metadata("design:type", Number)
], Job.prototype, "retryCount", void 0);
__decorate([
    Index(),
    Column('float', { nullable: true }),
    __metadata("design:type", Number)
], Job.prototype, "duration", void 0);
__decorate([
    Index(),
    Column(),
    __metadata("design:type", String)
], Job.prototype, "type", void 0);
__decorate([
    Column('jsonb', { nullable: false }),
    __metadata("design:type", Object)
], Job.prototype, "data", void 0);
__decorate([
    Column('jsonb', { nullable: true }),
    __metadata("design:type", Object)
], Job.prototype, "result", void 0);
__decorate([
    Column('jsonb', { nullable: true }),
    __metadata("design:type", Object)
], Job.prototype, "error", void 0);
Job = __decorate([
    Entity(),
    Index(['type', 'status'])
], Job);
export { Job };
//# sourceMappingURL=data:application/json;base64,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